/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StoricoEntryDTO } from './storico-entry-dto';


export interface StoricoCampoDTO { 
    target?: StoricoCampoDTOTargetEnum;
    identificatore?: string;
    etichetta?: string;
    cronologia?: Array<StoricoEntryDTO>;
}
export enum StoricoCampoDTOTargetEnum {
    PRATICA_ROOT = 'PRATICA_ROOT',
    ANAGRAFICA = 'ANAGRAFICA',
    COMPONENTE = 'COMPONENTE',
    EAV = 'EAV'
};



